import { AdminGuard } from './core/admin.guard';
import { AuthGuard } from './core/auth.guard';
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { CoreModule } from './core/core.module';

import { AppComponent } from './app.component';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { environment } from '../environments/environment';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { KursanciComponent } from './kursanci/kursanci.component';
import { KursanciService } from './services/kursanci.service';
import { KursantDetailsComponent } from './kursanci/kursant-details/kursant-details.component';
import { KursantGrupaComponent } from './kursant-grupa/kursant-grupa.component';
import { GrupyComponent } from './grupy/grupy.component';
import { KursantFormComponent } from './kursanci/kursant-form/kursant-form.component';
import { KursantNewComponent } from './kursant-new/kursant-new.component';
import { KursantResolver } from './services/kursant.resolver';
import { GrupaNewComponent } from './grupa-new/grupa-new.component';
import { GrupaFormComponent } from './grupy/grupa-form/grupa-form.component';
import { GrupaResolver } from './services/grupa.resolver';
import { GrupaDetailsComponent } from './grupy/grupa-details/grupa-details.component';
import { AngularFireDatabaseModule} from "angularfire2/database";

@NgModule({
  declarations: [
      AppComponent,
      DashboardComponent,
      UserProfileComponent,
      TableListComponent,
      TypographyComponent,
      IconsComponent,
      MapsComponent,
      NotificationsComponent,
      UpgradeComponent,
      KursanciComponent,
      KursantDetailsComponent,
      KursantGrupaComponent,
      GrupyComponent,
      KursantFormComponent,
      KursantNewComponent,
      GrupaNewComponent,
      GrupaFormComponent,
      GrupaDetailsComponent,
  ],
  imports: [
      BrowserModule,
      FormsModule,
      HttpModule,
      ComponentsModule,
      RouterModule,
      AppRoutingModule,
      AngularFireModule.initializeApp(environment.firebase),
      AngularFireDatabaseModule,
      AngularFirestoreModule,
      ReactiveFormsModule,
      CoreModule,
  ],
  providers: [
      KursanciService, KursantResolver, GrupaResolver, AuthGuard, AdminGuard,
      { provide: LOCALE_ID, useValue: 'pl-PL' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts